export default __webpack_public_path__ + "static/media/ComeBack.ea3e5631.png";